import { Component, Inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NZ_DRAWER_DATA, NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UmasData } from '../../../shared/models';
import { id } from 'date-fns/locale';
import { CatalogosService } from '../../../shared/services/catalogos.service';



@Component({
  selector: 'app-formulario-uma',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzDatePickerModule,
    NzInputNumberModule
  ],
  templateUrl: './formulario-uma.component.html',
  styleUrl: './formulario-uma.component.scss'
})
export class FormularioUmaComponent implements OnInit {
  umaForm!: FormGroup;
  isEdit = false;
  @Input() data: UmasData | undefined;
  constructor(
    private fb: FormBuilder,
    private drawerRef: NzDrawerRef<FormularioUmaComponent>,
    private message: NzMessageService,
    private catalogosService: CatalogosService,
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  private initForm(): void {
    this.umaForm = this.fb.group({
      id: [this.data ? this.data.id : 0],
      anio: [ this.data ? this.data.anio : this.getAnioActual(), [Validators.required, Validators.min(2000), Validators.max(2050)]],
      valorUma: [this.data ? this.data.valorUma : null, [Validators.required, Validators.min(0.01)]],
    });
    this.umaForm.get('anio')?.disable();
  }

  private getAnioActual(): number {
    return new Date().getFullYear();
  }

  onSubmit(): void {
    if (!this.umaForm.valid) {
      this.markAllFieldsAsTouched();
      this.message.error('Por favor, completa todos los campos requeridos');
      return;
    }

    let data = this.umaForm.getRawValue();
    if( this.data ) {
      delete data.anio;
      this.catalogosService.actualizarUMA(data).subscribe({
        next: (res) => {
          this.message.success('UMA actualizada correctamente');
          this.drawerRef.close(true);
        },
        error: (err) => {
          const details = err.error?.error?.details?.toString() || '';
          this.message.error('Error al actualizar la UMA: ' + details);
        }
      });
    }
    else {
      this.catalogosService.addUMA(data).subscribe({
        next: (res) => {
          this.message.success('UMA agregada correctamente');
          this.drawerRef.close(true);
        },
        error: (err) => {
          const details = err.error?.error?.details?.toString() || '';
          this.message.error('Error al agregar la UMA: ' + details);
        }
      });
    }
  }
  
  private markAllFieldsAsTouched(): void {
    Object.keys(this.umaForm.controls).forEach(key => {
      this.umaForm.get(key)?.markAsTouched();
    });
  }

  private parseLocalDate(dateString: string): Date | null {
    if (!dateString) return null;
    
    if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}/.test(dateString)) {
      const parts = dateString.split('T')[0].split('-');
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const day = parseInt(parts[2], 10);
      
      return new Date(year, month, day);
    }
    
    return new Date(dateString);
  }

  private formatDateToString(date: Date): string {
    if (!date || !(date instanceof Date)) return '';
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  }

  get isFormValid(): boolean {
    return this.umaForm.valid;
  }
}
